const c = (e, o, t) => {
  e.splice(t, 0, o);
};
export { c as addItemToSubmenu };